/* FT GUYS - the header wordmark tunes into the parallel-universe signal.

   The logo already performs a COORDINATE READOUT on load (ft-logo-split.js): the
   mark parts and a monospaced line resolves to PARALLEL UNIVERSE / <where you are>.
   This reuses that exact two-line language as an occasional status blip:

     SLOW / data-saver  ->  PARALLEL UNIVERSE / SIGNAL WEAK   (orange, more often — it's information)
     GOOD network       ->  PARALLEL UNIVERSE / CONNECTION ESTABLISHED  (green, rare — it's flair)

   It reframes a slow load as lore instead of a broken page, and rewards a fast one
   with a "portal locked" beat.

   COST: one interval (rare on good networks), paused when the tab is hidden,
   animating only opacity for ~2.5s. No scroll listeners. Cannot affect scroll/speed.

   PREVIEW: add ?ftsignal to any URL to force it (fast cadence). ?ftsignal=weak or
   ?ftsignal=good forces that mood regardless of your real connection. */
(function () {
  'use strict';

  var m = /[?&]ftsignal(?:=([a-z0-9]+))?/i.exec(location.search);
  var force = !!m;
  var forceMode = (m && m[1] || '').toLowerCase();

  var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var et = (c && c.effectiveType) || '';
  var save = !!(c && c.saveData);

  var slow;
  if (forceMode === 'weak') slow = true;
  else if (forceMode === 'good') slow = false;
  else slow = save || et === 'slow-2g' || et === '2g' || et === '3g';

  var ACCENT = '#ff5c1a';   // orange — signal weak
  var GOOD = '#38e8a0';     // green — signal locked
  var INK = '#f5efe8';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var STATUS, TONE, EVERY;
  if (slow) {
    if (save) STATUS = ['LOW BANDWIDTH', 'HOLDING THE PORTAL OPEN', 'SIGNAL WEAK'];
    else if (et === '3g') STATUS = ['RECONNECTING…', 'SIGNAL WEAK', 'HOLDING THE PORTAL OPEN'];
    else STATUS = ['SIGNAL WEAK', 'RECONNECTING…', 'LOW BANDWIDTH'];
    TONE = ACCENT;
    EVERY = et === '3g' ? 46000 : (save ? 50000 : 34000);
  } else {
    STATUS = ['CONNECTION ESTABLISHED', 'PORTAL STABLE', 'SIGNAL LOCKED'];
    TONE = GOOD;
    EVERY = 140000;   // rare — it's flavour, not information
  }

  var BOOT = 14000;
  if (force) { EVERY = 9000; BOOT = 3000; }

  var GLYPHS = 'アイウエオカキクケコサシスセソタチツテト0123456789';
  var idx = 0, timer = 0, busy = false, styled = false, logo = null;

  function pick(s) { return s.charAt(Math.floor(Math.random() * s.length)); }

  function css() {
    if (styled) return; styled = true;
    var s = document.createElement('style');
    s.textContent =
      '.ft-sig{position:absolute;z-index:5;pointer-events:none;white-space:nowrap;text-align:center;' +
        'transform:translate(-50%,-50%);opacity:0;transition:opacity .42s ease;' +
        'font-family:ui-monospace,SFMono-Regular,"SF Mono",Menlo,Consolas,monospace;}' +
      '.ft-sig.is-on{opacity:1;}' +
      '.ft-sig__l{display:block;color:' + ACCENT + ';font-size:7px;letter-spacing:.16em;line-height:1.15;}' +
      '.ft-sig__c{display:block;font-size:9px;letter-spacing:.14em;line-height:1.2;opacity:.95;margin-top:3px;}';
    document.head.appendChild(s);
  }

  function findLogo() {
    var g = document.getElementById('header-group');
    if (!g) return null;
    return g.querySelector('.header__logo img') || g.querySelector('.header-logo__image') ||
           g.querySelector('a[href="/"] img') || g.querySelector('.header__heading-logo') || null;
  }

  function scramble(el, target, dur, done) {
    if (reduced) { el.textContent = target; if (done) done(); return; }
    var frames = Math.max(8, Math.round(dur / 40)), f = 0;
    var iv = setInterval(function () {
      f++;
      var out = '';
      for (var i = 0; i < target.length; i++) {
        var ch = target[i];
        if (ch === ' ') { out += ' '; continue; }
        out += (f / frames) > (i / target.length) ? ch : pick(GLYPHS);
      }
      el.textContent = out;
      if (f >= frames) { clearInterval(iv); el.textContent = target; if (done) done(); }
    }, 40);
  }

  function blip() {
    if (busy || document.hidden) return;
    var g = document.getElementById('header-group');
    if (!g) return;
    // don't collide with the load-time logo reveal
    if (g.querySelector('.ft-logo.is-performing')) return;
    logo = logo || findLogo();
    if (!logo) return;
    var lr = logo.getBoundingClientRect();
    var gr = g.getBoundingClientRect();
    if (!lr.width) return;
    busy = true;
    css();

    var sig = document.createElement('span');
    sig.className = 'ft-sig';
    sig.setAttribute('aria-hidden', 'true');
    sig.style.left = (lr.left - gr.left + lr.width / 2) + 'px';
    sig.style.top = (lr.top - gr.top + lr.height / 2) + 'px';
    var l = document.createElement('span'); l.className = 'ft-sig__l'; l.textContent = 'PARALLEL UNIVERSE';
    var cc = document.createElement('span'); cc.className = 'ft-sig__c'; cc.style.color = TONE;
    sig.appendChild(l); sig.appendChild(cc);
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    g.appendChild(sig);

    var status = STATUS[idx % STATUS.length]; idx++;
    var prev = logo.style.opacity;
    logo.style.transition = 'opacity .42s ease';

    requestAnimationFrame(function () {
      logo.style.opacity = '0';
      sig.classList.add('is-on');
      scramble(cc, status, 900);
    });

    setTimeout(function () {
      sig.classList.remove('is-on');
      logo.style.opacity = prev || '1';
      setTimeout(function () { if (sig.parentNode) sig.remove(); busy = false; }, 480);
    }, reduced ? 2200 : 2600);
  }

  function startTimer() { if (!timer) timer = setInterval(blip, EVERY); }
  function stopTimer() { if (timer) { clearInterval(timer); timer = 0; } }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopTimer(); else startTimer();
  });

  function boot() {
    // let the load-time logo reveal finish first, then one blip, then settle into the interval
    setTimeout(function () { if (!document.hidden) { blip(); startTimer(); } }, BOOT);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
